const url = {
  LIST_DEV_URL: 'https://bbs.zm1v1.com',
  LIST_UAT_URL: 'https://bbs.uat.zmops.cc',
  LIST_PRO_URL: 'https://bbs.zhangmen.com',
  WWW_DEV_URL: 'https://v2-test-internal.zmaxis.com/api',
  WWW_PRO_URL: 'https://www-internal.zhangmen.com/api',
  MARKET_DEV_URL: 'https://statistics-test.zmlearn.com',
  MARKET_UAT_URL: 'https://statistics.uat.zmops.cc',
  MARKET_PRO_URL: 'https://statistics.zmlearn.com',
  NODE_DEV_URL: 'http://10.29.189.19:7001',
  NODE_UAT_URL: 'http://node-api.uat.zmops.cc',
  NODE_PRO_URL: 'http://10.80.112.176:7001'
}

let listURL, wwwURL, marketURL, nodeURL, aiH5PageURL

if (process.env.BUILD_ENV === 'production') {
  listURL = url.LIST_PRO_URL
  wwwURL = '/api'
  marketURL = url.MARKET_PRO_URL
  nodeURL = url.NODE_PRO_URL
  aiH5PageURL = 'https://ai-cativity-h5.zmtalent.com/wechat-operation/success1'
}

if (process.env.BUILD_ENV === 'uat') {
  listURL = url.LIST_UAT_URL
  wwwURL = '/api'
  marketURL = url.MARKET_UAT_URL
  nodeURL = url.NODE_UAT_URL
  aiH5PageURL = 'http://ai-activity-h5-test.zmaxis.com/wechat-operation/success1'
}

if (process.env.BUILD_ENV === 'development' || process.env.BUILD_ENV === 'testing') {
  listURL = url.LIST_DEV_URL
  wwwURL = url.WWW_DEV_URL
  marketURL = url.MARKET_DEV_URL
  nodeURL = url.NODE_DEV_URL
  aiH5PageURL = 'http://ai-activity-h5-test.zmaxis.com/wechat-operation/success1'
}

export default {
  listURL,
  wwwURL,
  marketURL,
  nodeURL,
  aiH5PageURL
}
